/* eslint-disable max-statements */
/* eslint-disable complexity */
/*eslint-disable no-console */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { takeEvery, select, call, all, take } from 'redux-saga/effects';
import { isEmpty, identity, isUndefined } from '@mindtickle/utils';
import { mixpanelIdentity, mixpanelIdentityPath } from '../config';
import { DISABLE_TRACKING } from '../config/constants';
import mixpanelManager from '../helpers/mixpanelManager';
var trackingEvents = {};
/********* to be removed **********/
export var mixpanelClient = {
    track: function (event, data) {
        console.log('MIX_PANEL EVENT: ', event, ', DATA: ', data);
    },
};
/********* to be removed **********/
function getDataFromStore(path, store) {
    if (path === void 0) { path = ''; }
    if (typeof path == 'string' && path.startsWith('@@store')) {
        path = path.split('.').splice(1);
        return path.reduce(function (result, key, index) { return (index !== path.length - 1 ? result[key] || {} : result[key]); }, store);
    }
    return path;
}
export function getBaseProperties(mixpanelPaths, mixpanelIdentity, store) {
    var baseProperties = {};
    Object.keys(mixpanelPaths).forEach(function (property) {
        var path = mixpanelPaths[property];
        var value;
        path = Array.isArray(path) ? path : [path];
        for (var i = 0; i < path.length; i++) {
            value = getDataFromStore(path[i], store);
            if (value) {
                break;
            }
        }
        var _a = mixpanelIdentity[property] || {}, names = _a.name, _b = _a.processor, processor = _b === void 0 ? identity : _b;
        names = Array.isArray(names) ? names : [names];
        names.forEach(function (name) {
            baseProperties[name] = processor(value);
        });
    });
    return baseProperties;
}
function getPropertyData(eventData, params, store) {
    var propertyData = {};
    Object.keys(eventData).forEach(function (key) {
        var _a = eventData[key], path = _a.value, _b = _a.processor, processor = _b === void 0 ? identity : _b;
        var value = getDataFromStore(path, store);
        propertyData[key] = processor(value, params);
    });
    return propertyData;
}
function getMixpanelIdentity(_a) {
    var mixpanelPath, additionalPath, store, type;
    var _b = _a.context, context = _b === void 0 ? {} : _b, _c = _a.mixpanel, mixpanel = _c === void 0 ? {} : _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                mixpanelPath = __assign(__assign({}, mixpanel), mixpanelIdentityPath);
                additionalPath = {};
                return [4 /*yield*/, select()];
            case 1:
                store = _d.sent();
                if (!isEmpty(context)) {
                    type = context.type || context.moduleType;
                    additionalPath = (store[type.toLowerCase()] && store[type.toLowerCase()].mixpanel) || {};
                }
                return [2 /*return*/, getBaseProperties(__assign(__assign({}, mixpanelPath), additionalPath), mixpanelIdentity.get(), store)];
        }
    });
}
function fireEvent(_a) {
    var store, TrackEventConfig, mixpanelMeta, trackingData, baseProperties, params, eventData, event_1, mixpanelData, error_1;
    var actionType = _a.type, _b = _a.payload, _c = _b === void 0 ? {} : _b, _d = _c.data, payloadData = _d === void 0 ? {} : _d, rest = __rest(_c, ["data"]);
    return __generator(this, function (_e) {
        switch (_e.label) {
            case 0:
                _e.trys.push([0, 3, , 4]);
                return [4 /*yield*/, select()];
            case 1:
                store = _e.sent();
                TrackEventConfig = trackingEvents[actionType] || {};
                mixpanelMeta = {
                    op: payloadData.operation || rest.operation,
                    opType: payloadData.type || rest.type,
                    response: payloadData.response || rest.response || {},
                    postData: payloadData.postData || rest.postData || {},
                    context: payloadData.context || rest.context || {},
                    mixpanel: payloadData.mixpanel || rest.mixpanel || {},
                };
                if (mixpanelMeta.postData.disableEvent)
                    return [2 /*return*/];
                trackingData = __assign({}, TrackEventConfig);
                trackingData = mixpanelMeta.op ? trackingData[mixpanelMeta.op] : trackingData;
                trackingData =
                    trackingData && mixpanelMeta.opType && mixpanelMeta.op
                        ? trackingData[mixpanelMeta.opType]
                        : trackingData;
                if (isEmpty(trackingData) || isUndefined(trackingData))
                    return [2 /*return*/];
                return [4 /*yield*/, call(getMixpanelIdentity, {
                        context: mixpanelMeta.context,
                        mixpanel: mixpanelMeta.mixpanel,
                    })];
            case 2:
                baseProperties = _e.sent();
                params = isEmpty(mixpanelMeta.postData) || isUndefined(mixpanelMeta.postData)
                    ? mixpanelMeta.response
                    : mixpanelMeta.postData;
                eventData = trackingData.data, event_1 = trackingData.event;
                if (isUndefined(eventData) || isUndefined(event_1))
                    return [2 /*return*/];
                mixpanelData = __assign(__assign({}, baseProperties), getPropertyData(eventData, params, store));
                if (process.env.IS_DEV || process.env.isDev) {
                    mixpanelClient.track(event_1, mixpanelData);
                }
                else if (process.env.TRACKING) {
                    mixpanelManager.track(event_1, mixpanelData);
                }
                return [3 /*break*/, 4];
            case 3:
                error_1 = _e.sent();
                if (process.env.IS_DEV || process.env.isDev) {
                    throw error_1;
                }
                return [3 /*break*/, 4];
            case 4: return [2 /*return*/];
        }
    });
}
export function trackEvents(events) {
    if (events === void 0) { events = {}; }
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                trackingEvents = __assign(__assign({}, trackingEvents), events);
                return [4 /*yield*/, takeEvery(Object.keys(events), fireEvent)];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
function stopTracking() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, take(DISABLE_TRACKING)];
            case 1:
                _a.sent();
                if (!(window.mixpanel && window.mixpanel.register)) return [3 /*break*/, 3];
                return [4 /*yield*/, window.mixpanel.register({ $ignore: true })];
            case 2:
                _a.sent();
                _a.label = 3;
            case 3: return [2 /*return*/];
        }
    });
}
export default function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, all([stopTracking()])];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
//# sourceMappingURL=index.js.map